exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.stepRow[data-v-81377a36] {\n  margin-bottom: 2em;\n}\n.stepRow .stepNumber[data-v-81377a36] {\n    font-size: 16px;\n    border-radius: 9999px;\n    width: 30px;\n    max-width: 30px;\n    min-width: 30px;\n    text-align: center;\n    height: 30px;\n    padding-top: 1px;\n    font-weight: bold;\n    margin-right: 1em;\n}\n.stepRow .stepButton[data-v-81377a36] {\n    white-space: nowrap;\n    width: 150px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-81377a36","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/otas/getYourGuide/howToConnect/howToConnect.vue
// module id = 3190
// module chunks = 0